import React, { useState, useEffect } from 'react';

import EventAccordion, { EventAccordionProps } from 'Components/Accordion/Event';

import { Container } from './EventAccordions.styled';

export interface Props {
    items: EventAccordionProps[];
}

const Event: React.FC<Props> = props => {
    const { items } = props;
    const [hash, setHash] = useState('');

    useEffect(() => {
        const updateAccordion = () => {
            setHash(window.location.hash);
        };
        updateAccordion();

        window.addEventListener('hashchange', updateAccordion);
        return () => {
            window.removeEventListener('hashchange', updateAccordion);
        };
    }, []);

    return items.length !== 0 ? (
        <Container>
            {items.map(item => (
                <EventAccordion
                    key={item.id}
                    {...item}
                    defaultOpen={hash === `#${item.id}` ? true : false}
                />
            ))}
        </Container>
    ) : null;
};

export default Event;
